import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    allAssets: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for all assets breadcrumb */
            allAssets: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearch_ResultAssetItem.allAssets?c=10wamqvibxez4", defaultMessage: "All Assets" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
